export default __webpack_public_path__ + "static/media/y4-avata.afc86dbe.png";